import { WorkspaceEngine } from "services/engines/engine.types";

import { Panel } from "../Panel";
import { CollapsedHeader } from "./CollapsedHeader";
import { EngineMenuActions } from "./EngineRow/EngineMenu";
import { EngineRow } from "./EngineRow/EngineRow";

import styles from "./styles.module.scss";

export const CollapsedPanel = (props: {
  items: WorkspaceEngine[];
  pinnedItems?: WorkspaceEngine[];
  pinnedLabel?: string;
  pinnedEngineNames?: Set<string>;
  onTogglePin?: (engineName: string) => void;
  actions: EngineMenuActions;
  testId?: string;
}) => {
  const {
    items,
    pinnedItems,
    pinnedLabel,
    pinnedEngineNames,
    onTogglePin,
    actions,
    testId,
  } = props;
  const showPinned = Boolean(pinnedItems?.length);
  const showSeparator = Boolean(showPinned && items.length);
  const renderRow = (engine: WorkspaceEngine) => {
    return (
      <EngineRow
        key={engine.engineName}
        engine={engine}
        actions={actions}
        isPinned={pinnedEngineNames?.has(engine.engineName)}
        onTogglePin={onTogglePin}
      />
    );
  };

  return (
    <Panel testId={testId}>
      <CollapsedHeader />
      <div className={styles.enginesList}>
        {showPinned && pinnedLabel && (
          <div className={styles.pinnedHeader}>{pinnedLabel}</div>
        )}
        {showPinned && pinnedItems?.map(engine => renderRow(engine))}
        {showSeparator && <div className={styles.separator} />}
        {items.map(engine => renderRow(engine))}
      </div>
    </Panel>
  );
};
